import { WidgetTeacherPerson } from '../models/widget-teacher-person.model';
import { HOMEWORK_STATUS } from '../values/homeworks.values';
import { WidgetTeacherHomework } from '../models/widget-teacher-homework.model';

class HomeworksToolsServiceClass {

  getStudentHomeworkStatus(homeworks: WidgetTeacherHomework[]): string {
    let homeworkStatus: any = null;
    homeworks.forEach((h, i) => {
      if((homeworks[i].status !== HOMEWORK_STATUS.NEW) && 
        (homeworkStatus !== HOMEWORK_STATUS.NEW)) {
        if(homeworks[i].status !== HOMEWORK_STATUS.SEEN && 
          (homeworkStatus !== HOMEWORK_STATUS.SEEN)) {
          homeworkStatus = homeworks[i].status;
        } else {
          homeworkStatus = HOMEWORK_STATUS.SEEN;
        }  
      } else {
        homeworkStatus = HOMEWORK_STATUS.NEW;
      }
    });
    return homeworkStatus;
  }

}

export const HomeworksToolsService = new HomeworksToolsServiceClass();